import { AuthService } from '../../../shared/services/auth.service';
import { Subject, Subscription } from 'rxjs';
import { finalize, switchMap, takeUntil } from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DashboardService } from '../../../shared/services/dashboard.service';

@Component({
  selector: 'app-calls',
  templateUrl: './calls.component.html',
  styleUrls: ['./calls.component.scss']
})
export class CallsComponent implements OnInit, OnDestroy {

  date: string;
  page = 1;
  perPage = 8;
  activeTab: 'automation' | 'broadcast' = 'automation';
  loading = false;
  result: any;
  broadcastResult: any;
  subscriptions: Subscription[] = [];
  private paginatedSub: Subscription;

  get title(): string {
    const date = this.date.split('-').reverse().join('/');
    return `Ligações Enviadas em ${date}`;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private dashboardService: DashboardService,
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.params.subscribe(params => {
        this.date = params.date;
      }),
      this.route.queryParams.subscribe(params => {
        this.page = params.page || this.page;
        this.perPage = params.per_page || this.perPage;
        this.activeTab = params.tab || 'automation';
        this.listPaginated();
      }),

      this.authService.userChanged.subscribe(() => this.listPaginated())
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.paginatedSub?.unsubscribe();
  }

  listPaginated(): void {
    this.paginatedSub?.unsubscribe();
    this.loading = true;

    if (this.activeTab === 'automation') {
      this.paginatedSub = this.dashboardService.callsPaginated(this.date, this.page, this.perPage)
        .pipe(finalize(() => this.loading = false))
        .subscribe(result => this.result = result);
    } else {
      this.paginatedSub = this.dashboardService.callsBroadcastPaginated(this.date, this.page, this.perPage)
        .pipe(finalize(() => this.loading = false))
        .subscribe(result => this.broadcastResult = result);
    }
  }

  onTabChange(tab: 'automation' | 'broadcast'): void {
    this.activeTab = tab;
    this.page = 1;
    this.listPaginated();
    this.router.navigate(['/calls-report', this.date], {
      queryParams: {
        page: this.page,
        tab: this.activeTab
      }
    });
  }

  pageChanged(page: number): void {
    this.router.navigate(['/calls-report', this.date], {
      queryParams: {
        page,
        tab: this.activeTab
      }
    });
  }

  back(): void {
    const queryParams = {
      month: +this.date.split('-')[1],
      year: +this.date.split('-')[0]
    };
    this.router.navigate(['/calls-report'], { queryParams });
  }

  formatPabxStatus(status: string): string {
    const labels: Record<string, string> = {
      'ANSWER': 'Atendida',
      'NOANSWER': 'Não atendida',
      'BUSY': 'Ocupado',
      'CONGESTION': 'Congestionado',
      'CHANUNAVAIL': 'Indisponível',
      'CANCELLED': 'Cancelado',
    };
    return labels[status] || status || 'Aguardando';
  }

  formatDuration(seconds: number | null): string {
    if (!seconds) { return '-'; }
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  }
}
